<template>
    <div>
        <template>
            <div class="flex items-center leading-none py-1">
                <feather-icon color="primary" icon="UserIcon" svgClasses="h-6 w-6 mr-4" />
                <div class="flex w-full flex-nowrap justify-between">
                    <span class="text-lg mr-4"> {{ displayName }} </span>
                    <span class="text-lg font-bold italic text-right"> </span>
                </div>
            </div>
            <div class="ml-3 pl-6 mt-2 right-bordered">
                <div class="flex w-full flex-nowrap justify-between">
                    <div>
                        <vx-address class="mr-3" :value="address" />
                    </div>
                    <div class="text-right">
                        <p>{{ dateOfBirth }}</p>
                    </div>
                </div>
                <div></div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'patient-suggest-item',
    props: {
        patient: {
            type: Object,
            required: true
        }
    },
    computed: {
        dateOfBirth() {
            const dob = this.patient.dateOfBirth
            return dob
                ? new Date(dob).toLocaleDateString('en-US', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                  })
                : ''
        },
        address() {
            return this.patient.address
        },
        displayName() {
            var test = `${this.patient.firstName} ${this.patient.lastName}`
            return test
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.left-bordered {
    border-left: 1px solid rgba(var(--vs-dark), 1);
}
</style>
